
import React from "react";
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CsLineIcons from '../../cs-line-icons';

class ConditionalButton extends React.Component {

    get caption() {
        if (typeof this.props.children !== "string") return this.props.children;
        const caption = this.props.children.trim();
        const normalized = {
            ok: "OK",
            cancel: "Cancel",
            delete: "Delete",
            save: "Save",
            import: "Import",
            apply: "Apply",
            "remove expenses": "Remove Expenses",
            "remove time": "Remove Time",
            "write check": "Write Check"
        };
        return normalized[caption.toLowerCase()] || this.props.children;
    }

    get defaultButtonClass() {
        return "btn-icon btn-icon-start ms-0 ms-sm-1 w-100 w-md-auto";
    }

    get defaultPlacement() {
        return "bottom";
    }

    get button() {
        const caption = this.caption;
        const disabled = !this.props.enabled && !this.props.onDisabledClick;

        return (
            <Button
                style={ this.props.style }
                variant={this.props.enabled ? this.props.enabledVariant : this.props.disabledVariant}
                className={this.props.className || this.defaultButtonClass}
                disabled={disabled}
                onClick={this.props.enabled ? this.props.onEnabledClick : this.props.onDisabledClick}
            >
                {this.props.icon ? <CsLineIcons style={ this.props.iconStyle } icon={this.props.icon} /> : null}
                {caption ? <span> {caption}</span> : null}
            </Button>
        );
    }

    get overlay() {
        return (
            <OverlayTrigger delay={{ show: 10, hide: 0 }} overlay={<Tooltip>{this.props.tooltip}</Tooltip>} placement={this.props.overlayPlacement || this.defaultPlacement}>
                {this.button}
            </OverlayTrigger>
        );
    }
    render() {
        if (this.props.display) {
            return (this.props.enabled && this.props.tooltip) ?
                    this.overlay
                    :
                    this.button
        }
        return null;
    }
}

export default ConditionalButton;
